<template>
  <div>
    <div id="container" style="width:100%;height:500px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchService: null,
      ipLocation: null,
      resultsMap: [],
      markers: null,
      infoWindowList: [],
      marker: null,
      tmap: null,
      LatLngs: [39.916527, 116.397128],
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    //移除marker事件
    removeMarker() {
      var _this = this;
      if (_this.marker) {
        _this.marker.setMap(null);
        _this.marker = null;
      }
    },
    // 创建marker
    createMarker(latitude, longitude) {
      var _this = this;
      if (!_this.marker) {
        _this.marker = new TMap.MultiMarker({
          id: "marker-layer",
          map: _this.tmap,
          styles: {
            marker: new TMap.MarkerStyle({
              width: 25,
              height: 35,
              anchor: { x: 16, y: 32 },
              src:
                "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png",
            }),
          },
          geometries: [
            {
              id: "demo",
              styleId: "marker",
              position: new TMap.LatLng(latitude, longitude),
              properties: {
                title: "marker",
              },
            },
          ],
        });
      }
    },
    // 搜索提示
    getSuggestionsFunc(keyword) {
      _this.suggestion.getSuggestions({ keyword }).then((res) => {
        console.log(res);
      });
    },
    // 搜索
    searchByKeyWord(keyword, city) {
      var _this = this;
      // _this.infoWindowList.forEach((infoWindow) => {
      //   _this.infoWindow.close();
      // });
      // _this.infoWindowList.length = 0;
      // _this.markers.setGeometries([]);

      // 在地图显示范围内以给定的关键字搜索地点
      console.log(keyword, city);
      _this.searchService
        .searchRegion({
          keyword: keyword,
          cityName: city ? city.title : "中国",
        })
        .then((result) => {
          console.log("搜索结果", result);
          // _this.removeMarker();
          var coords = [];
          if (result.cluster) {
            _this.searchByKeyWord(keyword, result.cluster[0]);
            return;
          }
          result.data.forEach((item, index) => {
            // var geometries = _this.markers.getGeometries();

            var LatLng = new TMap.LatLng(item.location.lat, item.location.lng);
            coords.push(LatLng);
            // var infoWindow = new TMap.InfoWindow({
            //   map: _this.tmap,
            //   position: item.location,
            //   content: `<h3>${item.title}</h3><p>地址：${item.address}</p><p>电话：${item.tel}</p>`,
            //   offset: { x: 0, y: -50 },
            // }); // 新增信息窗体显示地标的名称与地址、电话等信息
            // infoWindow.close();
            // _this.infoWindowList[index] = infoWindow;
            // geometries.push({
            //   id: String(index), // 点标注数据数组
            //   position: item.location,
            // });
            // _this.markers.updateGeometries(geometries); // 绘制地点标注
            // _this.markers.on("click", (e) => {
            //   console.log(e);
            //   _this.infoWindowList[Number(e.geometry.id)].open();
            // }); // 点击标注显示信息窗体
          });
          // var latlngBounds = new TMap.LatLngBounds();
          // for (var i = 0; i < coords.length; i++) {
          //   console.log(coords[i]);
          //   latlngBounds.extend(coords[i]);
          // }
          _this.tmap.setCenter(coords[0]);
          _this.removeMarker();
          _this.createMarker(coords[0].lat, coords[0].lng);
          _this.showpoint({ lat: coords[0].lat, lng: coords[0].lng });
          // _this.tmap.fitBounds(latlngBounds);
        });
    },

    initMap() {
      var _this = this;
      var latLng = {
        lat: 39.984104,
        lng: 116.307503,
      };
      var center = new TMap.LatLng(39.984104, 116.307503);

      //初始化地图
      if (!_this.tmap) {
        _this.tmap = new TMap.Map("container", {
          // rotation: 20, //设置地图旋转角度
          // pitch: 30, //设置俯仰角度（0~45）
          // zoom: 12, //设置地图缩放级别
          center: center, //设置地图中心点坐标
        });
      }

      _this.tmap.on("tilesloaded", function() {
        console.log("地图瓦片已加载完成");
        if (!_this.searchService) {
          _this.searchService = new TMap.service.Search({ pageSize: 10 });
          _this.markers = new TMap.MultiMarker({
            map: _this.tmap,
            geometries: [],
          });
          _this.infoWindowList = Array(500);
        }
        if (!_this.suggestion) {
          _this.suggestion = new TMap.service.Suggestion({ pageSize: 10 });
        }

        if (!_this.ipLocation) {
          _this.ipLocation = new TMap.service.IPLocation();
          _this.ipLocation
            .locate({})
            .then((result2) => {
              var { result } = result2;
              latLng.lat = result.location.lat;
              latLng.lng = result.location.lng;
              _this.tmap.setCenter(result.location);
              _this.createMarker(latLng.lat, latLng.lng);
              console.log(result2);
              _this.showpoint(latLng);
            })
            .catch((error) => {
              if (!_this.marker) {
                _this.createMarker(latLng.lat, latLng.lng);
              }
            });
        }
      });

      _this.tmap.on("click", function(evt) {
        // if (!_this.infoWindowList || _this.infoWindowList.length == 0) {
        _this.removeMarker();
        latLng.lat = evt.latLng.getLat().toFixed(6);
        latLng.lng = evt.latLng.getLng().toFixed(6);
        console.log(evt);
        _this.createMarker(latLng.lat, latLng.lng);
        _this.showpoint(latLng);
        // }
      });
    },
    init() {
      var _this = this;
      //步骤：定义map变量 调用 qq.maps.Map() 构造函数   获取地图显示容器
      //设置地图中心点
      var myLatlng = new qq.maps.LatLng(39.916527, 116.397128);

      // var myLatlng = new TMap.LatLng(39.916527, 116.397128);
      console.log(myLatlng);
      //定义工厂模式函数
      var myOptions = {
        zoom: 100, //设置地图缩放级别
        center: myLatlng, //设置中心点样式
        mapTypeId: qq.maps.MapTypeId.ROADMAP, //设置地图样式详情参见MapType
      };
      //获取dom元素添加地图信息
      var map = new qq.maps.Map(
        document.getElementById("container"),
        myOptions
      );
      //并获取鼠标点击的经纬度
      // var markersArr = [];
      qq.maps.event.addListener(map, "click", function(event) {
        // 去掉上一个点
        // if (markersArr.length != 0) {
        // 	markersArr[0].setMap(null);
        // 	markersArr.length = 0;
        // }
        _this.clearOverlays();
        this.longitude = event.latLng.getLat();
        this.latitude = event.latLng.getLng();
        // alert("经度:"+this.longitude+","+"纬度:"+this.latitude);
        //创建marker
        _this.showpoint(event.latLng);
        var marker = new qq.maps.Marker({
          position: event.latLng,
          map: map,
        });
        _this.markers.push(marker);
      });
      var latlngBounds = new qq.maps.LatLngBounds();
      //设置Poi检索服务，用于本地检索、周边检索
      this.searchService = new qq.maps.SearchService({
        //设置搜索范围为北京
        // location: "北京",
        //设置搜索页码为1
        pageIndex: 1,
        //设置每页的结果数为5
        pageCapacity: 5,
        //检索成功的回调函数
        complete: function(results) {
          //设置回调函数参数
          var pois = results.detail.pois;
          for (var i = 0, l = pois.length; i < l; i++) {
            var poi = pois[i];
            //扩展边界范围，用来包含搜索到的Poi点
            latlngBounds.extend(poi.latLng);
            var marker = new qq.maps.Marker({
              map: map,
              position: poi.latLng,
            });

            marker.setTitle(i + 1);

            _this.markers.push(marker);
          }
          //调整地图视野
          map.fitBounds(latlngBounds);
        },
        //若服务请求失败，则运行以下函数
        error: function() {
          alert("出错了。");
        },
      });
    },
    showpoint(latLng) {
      this.$emit("getPoint", latLng);
    },
    search(keyword) {
      let that = this;
      // that.clearOverlays([]);

      that.searchByKeyWord(keyword);
    },
    //清除地图上的marker
    clearOverlays(overlays) {
      this.markers.forEach((item) => {
        item.setMap(null);
      });
      this.markers.length = 0;
    },
  },
};
</script>
